module.exports = __webpack_public_path__ + "static/media/star.a7861168.svg";